import { modals } from '@mantine/modals'
import showModalNotificationError from '@v2/commons/modals/ModalNotification/showModalNotificationError'
import { ALL_ROUTES } from '@v2/domains/routing/constants/route-configs.constants'
import { useAppNavigation } from '@v2/domains/routing/hooks/useAppNavigation.hook'
import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'

import { useValidateMagicTokenMutation } from '../api/auth.api'

interface MagicTokenParams {
  isSuccess: boolean
}

const useValidateMagicToken = (): MagicTokenParams => {
  const [validateMagicToken, { isSuccess }] = useValidateMagicTokenMutation()
  const [params] = useSearchParams()
  const { navigateTo } = useAppNavigation()
  const token = params.get('token')

  const handleValidateMagicToken = async () => {
    if (!token) {
      return navigateTo(ALL_ROUTES.FORGOT_PASSWORD.path)
    }
    await validateMagicToken(token)
      .unwrap()
      .catch((e) => {
        showModalNotificationError({
          title: 'Link is no longer valid!',
          buttonText: 'Try again',
          path: ALL_ROUTES.FORGOT_PASSWORD.path,
          onClose: () => {
            modals.closeAll()
            setTimeout(() => {
              navigateTo(ALL_ROUTES.FORGOT_PASSWORD.key)
            }, 0)
          },
        })
      })
  }

  useEffect(() => {
    handleValidateMagicToken()
  }, [])

  return {
    isSuccess,
  }
}

export default useValidateMagicToken
